import { FunctionComponent } from 'react';

import { detectLocale, reloadPage } from '@helpers/window';

// Using hardcodded strings here because this error would show if the i18n translation service fails to load.
const STRINGS = {
  de: {
    title: 'Es ist ein Fehler aufgetreten',
    description: 'Es ist ein technischer Fehler aufgetreten. Bitte versuchen Sie es später erneut.',
    reload: 'Seite neu laden',
  },
  fr: {
    title: "Une erreur s'est produite",
    description: "Une erreur technique s'est produite. Veuillez réessayer plus tard.",
    reload: 'Recharger la page',
  },
  it: {
    title: 'Si è verificato un errore',
    description: 'Si è verificato un errore tecnico. Riprovare più tardi.',
    reload: 'Ricarica pagina',
  },
} as const;

const RootErrorBoundary: FunctionComponent = () => {
  const copy = STRINGS[detectLocale()];

  return (
    <div className="flex min-h-screen items-center justify-center p-8 text-center font-sans">
      <div>
        <h1>{copy.title}</h1>
        <p>{copy.description}</p>
        <button type="button" onClick={reloadPage} className="cursor-pointer px-6 py-3">
          {copy.reload}
        </button>
      </div>
    </div>
  );
};

RootErrorBoundary.displayName = 'RootErrorBoundary';

export { RootErrorBoundary };
